var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 2.5V15C16.875 15.1658 16.8091 15.3247 16.6919 15.4419C16.5747 15.5591 16.4158 15.625 16.25 15.625H5.625C5.2936 15.6254 4.97587 15.7572 4.74154 15.9915C4.5072 16.2259 4.37538 16.5436 4.375 16.875H15C15.1658 16.875 15.3247 16.9408 15.4419 17.0581C15.5592 17.1753 15.625 17.3342 15.625 17.5C15.625 17.6658 15.5592 17.8247 15.4419 17.9419C15.3247 18.0592 15.1658 18.125 15 18.125H3.75C3.58424 18.125 3.42528 18.0591 3.30807 17.9419C3.19086 17.8247 3.12501 17.6658 3.125 17.5V4.375C3.12576 3.71219 3.38939 3.07675 3.85807 2.60807C4.32675 2.13939 4.96219 1.87576 5.625 1.875H16.25C16.4158 1.87501 16.5747 1.94086 16.6919 2.05807C16.8091 2.17528 16.875 2.33424 16.875 2.5V2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.e3919ad1.svg";
export { ForwardRef as ReactComponent };